export enum AuthenticationError {
  invalidCredentials = 'invalidCredentials',
  unexpectedError = 'unexpectedError',
}
